// import React, { useState, useEffect } from "react";
// import "./SendResumeJob.css";
// import JobSearch from "../../../Assets/img/cv.png";
// import Header from "../../Hoc/Header";
// import Footer from "../../Hoc/Footer";
// import axios from "axios";
// import { Link, useParams } from "react-router-dom";
// import Loader from "react-loader-spinner";

// function Resume() {
//   const { id } = useParams();
//   const [posts, setPosts] = useState([]);
//   const [resumeId, setResumeId] = useState("");
//   const [loader, setLoader] = useState(true);
//   const [text, setText] = useState(false);

//   useEffect(() => {
//     getPosts();
//   }, [id]);

//   const getPosts = () => {
//     axios
//       .get(`https://arianaapp.arianaapply.com/api/V1/get-resume/${id}`)
//       .then((res) => {
//         console.log("gg", res);
//         if (!res.data || res.data.length === 0) {
//           setText(true);
//           setLoader(false);
//         } else {
//           setPosts(res.data);
//           setResumeId(res.data[0]._id);
//           setLoader(false);
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//         setLoader(false);
//       });
//   };

//   const downloadResume = () => {
//     window.location.href = `https://arianaapp.arianaapply.com/app/resume-download/${resumeId}`;
//   };

//   return (
//     <div className="send-resume-job">
//       <Header title="رزومه های من" />
//       <div className="job-list">
//         <div className="job-list-body">
//           {loader ? (
//             <div className="spinner">
//               <Loader
//                 type="TailSpin"
//                 color="rgb(236, 177, 28)"
//                 height={80}
//                 width={80}
//               />
//             </div>
//           ) : text ? (
//             <p className="font">رزومه ای ساخته نشده است</p>
//           ) : (
//             posts.map((post) => (
//               <div className="resume-list-title" key={post._id}>
//                 <div className="resume-profile-top">
//                   <h4>{post.name} رزومه </h4>
//                   <div className="profile-resume-icon">
//                     <img src={JobSearch} alt="JobSearch" />
//                   </div>
//                 </div>

//                 <div className="resume-edit-p">
//                   <Link to={`/single-resume/${post._id}`}>ویرایش</Link>
//                   <a onClick={downloadResume} style={{ cursor: "pointer" }}>
//                     دانلود و نمایش
//                   </a>
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// }

// export default Resume;




import React, { useState, useEffect } from "react";
import "./SendResumeJob.css";
import JobSearch from "../../../Assets/img/cv.png";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Loader from "react-loader-spinner";

function Resume() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loader, setLoader] = useState(true);
  const [text, setText] = useState(false);

  useEffect(() => {
    if (id) {
      getPosts();
    } else {
      setLoader(false);
      setText(true);
    }
  }, [id]);

  const getPosts = () => {
    // اگر توکن داری، از localStorage بگیر (معمولاً در این اپ‌ها هست)
    const token = localStorage.getItem("token");

    axios
      .get(`https://arianaapp.arianaapply.com/api/V1/get-resume/${id}`, {
        headers: token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : {},
      })
      .then((res) => {
        console.log("Resume response:", res.data);

        // پشتیبانی از هر دو حالت: آرایه یا آبجکت تکی
        let data = null;

        if (Array.isArray(res.data)) {
          data = res.data.length > 0 ? res.data[0] : null;
        } else if (res.data && typeof res.data === "object") {
          data = res.data;
        }

        if (!data || !data._id) {
          setText(true);
          setPost(null);
        } else {
          setPost(data);
          setText(false);
        }
        setLoader(false);
      })
      .catch((err) => {
        console.error("Error fetching resume:", err.response?.data || err.message);
        setLoader(false);
        setText(true);
        setPost(null);
      });
  };

  const downloadResume = () => {
    if (!post?._id) return;
    window.location.href = `https://arianaapp.arianaapply.com/app/resume-download/${post._id}`;
  };

  return (
    <div className="send-resume-job">
      <Header title="رزومه های من" />
      <div className="job-list">
        <div className="job-list-body">
          {loader ? (
            <div className="spinner">
              <Loader
                type="TailSpin"
                color="rgb(236, 177, 28)"
                height={80}
                width={80}
              />
            </div>
          ) : text || !post ? (
            <p className="font">رزومه ای ساخته نشده است</p>
          ) : (
            <div className="resume-list-title" key={post._id}>
              <div className="resume-profile-top">
                <h4>{post.name || "رزومه"} رزومه</h4>
                <div className="profile-resume-icon">
                  <img src={JobSearch} alt="JobSearch" />
                </div>
              </div>

              <div className="resume-edit-p">
                <Link to={`/single-resume/${post._id}`}>ویرایش</Link>
                <a
                  onClick={downloadResume}
                  style={{ cursor: "pointer" }}
                >
                  دانلود و نمایش
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Resume;